// Mock player data for frontend development
export const mockPlayers = [
  {
    id: 1,
    first_name: "Tejan Loco",
    last_name: "Jalloh",
    date_of_birth: "2006-05-20",
    nationality: { id: 1, name: "Sierra Leone", image: null },
    profile_picture: "/loco.jpg",
    position: "Forward",
    height_cm: 172,
    weight_kg: 65,
    dominant_foot: "Right",
    current_club: { id: 1, name: "Kamboi Eagles", image: null },
    wing: { id: 1, name: "Right" },
    contract_start: "",
    contract_end: "",
    market_value_usd: "N/A",
    appearances: "N/A",
    goals: "N/A",
    assists: "N/A",
    yellow_cards: "N/A",
    red_cards: "N/A",
    previous_clubs: "Kamboi Eagles",
    images: [],
    videos: [],
    highlight_video_1: null,
    highlight_video_2: null,
    highlight_video_3: null,
    highlight_video_4: null,
    highlight_video_5: null,
  },

];
